<template>
  <div
    v-click-outside="close"
    :class="[
      {
        [$style.active]: isHighlight,
        [$style.wrap]: true,
        [$style.disable]: disabled,
        [$style.readonly]: readonly,
        [$style.outline_none]: outline === 'none',
        [$style.outline_hover]: outline === 'hover',
        [$style.outline_always]: outline === 'always',
      },
      'vgp-interactive-element',
    ]"
    :style="{ 'font-size': '14px', height: '32px' }"
  >
    <div
      ref="trigger"
      :class="$style.select_inner"
      @click="toggle"
    >
      <div
        :class="$style.selected_items"
        :style="{ width: `calc(100% - ${resetBtnDelta}px)` }"
      >
        <span
          v-if="!localSelected.length"
          :class="$style.placeholder_txt"
        >
          {{ placeholder }}
        </span>

        <vgp-roll-items
          v-if="localSelected.length"
          :items="localSelected"
          :offset="4"
        >
          <template #default="{ item }">
            <vgp-chip
              preset="color"
              :bg-color="item.hex"
              :fill-width="false"
            />
          </template>
        </vgp-roll-items>
      </div>

      <div :class="[$style.d_flex, $style.ai_center, $style.ml_8]">
        <sprite
          v-show="isShowResetBtn"
          name="close-2"
          type="bold"
          :size="16"
          :class="[$style.mr_8, 'vgp_select_reset_btn']"
          @click.stop="onReset"
        />
        <sprite
          name="drop-down"
          type="bold"
          :size="24"
          :class="[$style.drop_arrow, 'vgp_select_drop_arrow']"
        />
      </div>
    </div>

    <context-menu
      v-if="isOpen"
      :position="palettePosition"
      :no-padding="true"
    >
      <template #body>
        <colors-palette
          :colors="colors"
          :multiselect="true"
          :selected="localSelected"
          @selectColors="onSelectColors"
        />
      </template>
    </context-menu>
  </div>
</template>

<script>
import vgpChip from '$$vueCmp/chip/vgpChip.vue';
import vgpRollItems from '$$uiKitComp/rollItems/vgpRollItems.vue';
import sprite from '$$uiKitComp/VueIcon/svgSprite.vue';
import colorsPalette from '$$uiKitComp/colorPalette/colorsList/colorsList.vue';
import contextMenu from '../../../views/common/VueComponents/popups/contextMenuPopup/contextMenuPopup.vue';

export default {
  name: 'VgpColorPaletteDropdown',

  components: {
    vgpChip, vgpRollItems, sprite, colorsPalette, contextMenu,
  },

  props: {
    selected: { type: Array, required: false, default: () => [] },
    placeholder: { type: String, required: false, default: 'Placeholder' },
    disabled: { type: Boolean, required: false, default: false },
    readonly: { type: Boolean, required: false, default: false },
    showResetBtn: { type: Boolean, required: false, default: true },
    highlightActiveState: { type: Boolean, required: false, default: false },
    outline: {
      type: String,
      required: false,
      default: 'always',
      validator: v => ['none', 'always', 'hover'].includes(v),
    },
  },

  emits: {
    onChange: [],
    selected: [],
    onResetClick: null,
  },

  data() {
    return {
      isOpen: false,
      localSelected: [],
      palettePosition: null,
    };
  },

  computed: {
    colors() {
      return this.$store.getters['teamSetting/colors'].data || [];
    },

    isHighlight() {
      return !this.disabled && (this.isOpen || (this.highlightActiveState && this.localSelected.length));
    },

    isShowResetBtn() {
      return this.showResetBtn && !this.disabled && this.localSelected.length > 0;
    },

    resetBtnDelta() {
      return this.isShowResetBtn ? 60 : 20;
    },
  },

  watch: {
    selected: {
      handler(val) {
        this.localSelected = this.resolveSelected(val);
      },
      immediate: true,
    },
  },

  methods: {
    resolveSelected(val) {
      const values = Array.isArray(val) ? val : (val ? [val] : []);

      if (!values.length) return [];

      // If values are already full color objects — use them as-is
      if (typeof values[0] === 'object') return values;

      // If values are IDs (numbers/strings) — look up in store
      return values.reduce((acc, id) => {
        const found = this.colors.find(c => c.id === +id);

        if (found) acc.push(found);

        return acc;
      }, []);
    },

    toggle() {
      if (this.disabled || this.readonly) return;

      if (this.isOpen) {
        this.close();
      } else {
        this.palettePosition = this.$refs.trigger.getBoundingClientRect();
        this.isOpen = true;
      }
    },

    close() {
      if (!this.isOpen) return;

      this.$emit('selected', [...this.localSelected]);
      this.isOpen = false;
      this.palettePosition = null;
    },

    onSelectColors(selectedColors) {
      this.localSelected = [...selectedColors];
      this.$emit('onChange', [...this.localSelected]);
    },

    onReset() {
      this.$emit('onResetClick');
      this.localSelected = [];
      this.$emit('onChange', []);
      this.$emit('selected', []);
    },
  },
};
</script>

<style module lang="less" src="./dropSelect.less" ></style>
